export const requestParentToSignIn = () => {
  window.parent.postMessage(
    {
      type: "OPEN_AUTH_POPUP",
      mode: "login",
    },
    process.env.REACT_APP_MOLLIES_IFRAME_HOST
  );
};

export const requestParentToSignUp = () => {
  window.parent.postMessage(
    {
      type: "OPEN_AUTH_POPUP",
      mode: "signup",
    },
    process.env.REACT_APP_MOLLIES_IFRAME_HOST
  );
};

export const checkIsInIframe = () => {
  return window.self !== window.top;
};
